module.exports = __webpack_public_path__ + "img/portalmanagement_users.1de4455a.png";